import Vue from 'vue';
import VueRouter from 'vue-router';
import DealDashboard from '../views/DealDashboard.vue';
import CaseDashboard from '../views/CaseDashboard.vue';
import Activity from '../views/Activity.vue';
import Deals from '../views/Deals.vue';
import Deal from '../views/Deal.vue';
import Login from "../views/Login.vue";
import ResetPassword from "../views/ResetPassword.vue";
import DataProcessingAgreement from "../views/DataProcessingAgreement.vue";
import Contacts from '../views/Contacts.vue';
import Contact from '../views/Contact.vue';
import Companies from '../views/Companies.vue';
import Orders from '../views/Orders.vue';
import Order from '../views/Order.vue';
import Account from '../views/Account.vue';
import Logout from '../views/Logout.vue';
import Campaigns from '../views/Campaigns.vue';
import Campaign from '../views/Campaign.vue';
import Segments from '../views/Segments.vue';
import Segment from '../views/Segment.vue';
import Cases from '../views/Cases.vue';
import Case from '../views/Case.vue';
import KnowledgeArticles from '../views/KnowledgeArticles.vue';
import KnowledgeArticle from '../views/KnowledgeArticle.vue';
import Setting from "../views/Setting.vue";
import PermissionError from "../views/PermissionError.vue";
import PermissionErrorPortal from "../views-gpt-portal/PermissionErrorPortal.vue";
import PageNotFound from "../views/PageNotFound.vue";
import Preference from "../views/Preference.vue";
import { ACCESS_TOKEN, REFRESH_TOKEN, TENANTCENTER_ACCESS_TOKEN, TENANTCENTER_REFRESH_TOKEN,  } from '../services/api/auth';
import i18n from '/common/plugins/vue-i18n.js';
import UpChat from '../views/UpChat.vue';
import BTN from '../components/UpChat/BTN.vue';
import CRM from '../components/UpChat/CRM.vue';
import WiadvanceDeal from '@/views-wiadvance/wiadvanceDeal.vue';
// GPT-----------------------------------------------
import UpgptLogin from '../views-gpt/UpgptLogin.vue';
import SsoUpgptLogin from '../views-gpt/SsoUpgptLogin.vue';
import SsoTscLogin from '../views-gpt/SsoTscLogin.vue';
import Knowledges from '../views-gpt/Knowledges.vue';
import Knowledge from '../views-gpt/Knowledge.vue';
import UsageAnalysis from '../views-gpt/UsageAnalysis.vue';
import AiBots from '../views-gpt/AiBots.vue';
import Agents from '../views-gpt/Agents.vue';
import AiBot from '../views-gpt/AiBot.vue';
import UploadRecord from '../views-gpt/UploadRecord.vue';
import GptUserSetting from '../views-gpt/UserSetting.vue';
import ChatHistory from '../views-gpt/ChatHistory.vue';
import ManageUsers from '../views-gpt/ManageUsers.vue';
import ManageGroups from '../views-gpt/ManageGroups.vue';
import MeetingRecaps from '../views-gpt/MeetingRecaps.vue';
import MeetingRecap from '../views-gpt/MeetingRecap.vue';
import AINotebooks from '../views-gpt/AINotebooks.vue';
import AINotebook from '../views-gpt/AINotebook.vue';
import UpMeeting from '../views-gpt/UpMeeting.vue';
import UpPortal from '@/views-gpt-portal/UpPortal.vue';
import UpPortalDisplayImage from '@/views-gpt-portal/UpPortalDisplayImage.vue';
import ManageWorkAgentDefinition from '../views-gpt/ManageWorkAgentDefinition.vue';
import UserAnalysis from "@/views-gpt/UserAnalysis.vue";
import ThreadAnalysis from "@/views-gpt/ThreadAnalysis.vue";
import LoginPageSetting from '../views-gpt/LoginPageSetting.vue';
// Urban Renewal Admin-----------------------------------------------
import UrbanRenewalAdminLogin from '../views/urbanrenewal/admin/Login.vue';
import UrbanRenewalAdminBasicData from '../views/urbanrenewal/admin/BasicData.vue';
import UrbanRenewalAdminStatistics from '../views/urbanrenewal/admin/Statistics.vue';
import UrbanRenewalAdminHeatmap from '../views/urbanrenewal/admin/Heatmap.vue';
import UrbanRenewalAdminSimulation from '../views/urbanrenewal/admin/Simulation.vue';
import UrbanRenewalAdminManualInput from '../views/urbanrenewal/admin/ManualInput.vue';
import UrbanRenewalAdminProjectSettings from '../views/urbanrenewal/admin/ProjectSettings.vue';
import UrbanRenewalAdminAdminSettings from '../views/urbanrenewal/admin/AdminSettings.vue';
import PreferenceService from '../services/PreferenceService';
// Urban Renewal Select (前台選配)---------------------------------
import UrbanRenewalSelectLogin from '../views/urbanrenewal/select/Login.vue';
import UrbanRenewalSelectForgotPassword from '../views/urbanrenewal/select/ForgotPassword.vue';
import UrbanRenewalSelectResetPassword from '../views/urbanrenewal/select/ResetPassword.vue';
import UrbanRenewalSelect from '../views/urbanrenewal/select/Select.vue';
// Tenant Center-----------------------------------------------
import TenantCenterLogin from '../views/TenantCenterLogin.vue';
import TenantCenterTenantList from "../views/TenantCenterTenantList.vue";
import TenantCenterUserList from "../views/TenantCenterUserList.vue";
import TenantCenterUsageSumarry from "../views/TenantCenterUsageSumarry.vue";
Vue.use(VueRouter);

// Urban Renewal Admin — Feature Flag cache & guard helper
let _propertySelectionEnabled = null;
async function isPropertySelectionEnabled() {
  if (_propertySelectionEnabled === null) {
    try {
      // Backend PreferenceView.get returns the raw value (e.g. the string "Y"),
      // NOT an object like { value: "Y" }. Compare against res.data directly.
      const res = await PreferenceService.getPropertySelection();
      _propertySelectionEnabled = res.data === 'Y';
    } catch (e) {
      // Do NOT cache failures (e.g. tenant/token not yet set) — otherwise a
      // transient error poisons the cache and blocks access even after a valid
      // login. Leave it null so the next guard call retries.
      return false;
    }
  }
  return _propertySelectionEnabled;
}

function _urbanRenewalLoginPath() {
  const tenant = window.localStorage.getItem('tenant') || '';
  return tenant ? '/urbanrenewal/admin/login?tenant=' + tenant : '/urbanrenewal/admin/login';
}

function _clearUrbanRenewalSession() {
  ['lastActive', 'idleTimeLimit', 'access_token', 'refresh_token', 'id_token',
   'tenant', 'user', 'is_staff', 'NoticeBoard_IsClose', 'isUpchatUser', 'isUpGPTUser',
   'upchat_login', 'sso'].forEach(function (k) { window.localStorage.removeItem(k); });
}

async function urbanRenewalAdminGuard(to, from, next) {
  const enabled = await isPropertySelectionEnabled();
  // 無權存取(功能關閉 / 非管理者)一律「登出→回選配系統登入頁」,不掉到 CRM。
  // loginPath 先取(含 tenant),再清 session(清除會移除 tenant)。
  if (!enabled) {
    const loginPath = _urbanRenewalLoginPath();
    _clearUrbanRenewalSession();
    return next(loginPath);
  }
  if (!(ACCESS_TOKEN in window.localStorage)) return next(_urbanRenewalLoginPath());
  if (window.localStorage.getItem('is_staff') !== 'true') {
    const loginPath = _urbanRenewalLoginPath();
    _clearUrbanRenewalSession();
    return next(loginPath);
  }
  next();
}

// Urban Renewal Select (前台選配) — guard helper
function _urbanRenewalSelectLoginPath() {
  const tenant = window.localStorage.getItem('tenant') || '';
  return tenant ? '/urbanrenewal/select/login?tenant=' + tenant : '/urbanrenewal/select/login';
}

function urbanRenewalSelectGuard(to, from, next) {
  // 前台不查 feature flag（無 CRM token；後端已把關）；僅驗 landowner token。
  if (!window.localStorage.getItem('ur_select_token')) {
    return next(_urbanRenewalSelectLoginPath());
  }
  next();
}

const PUBLIC_PATHS = ['/login','/upgpt-login','/sso-tsc-login','/sso-upgpt-login','/resetpassword','/upmeeting','/docs/DPF.pdf','/tenant_center/login', '/tenant_center/resetpassword', '/Logout', '/urbanrenewal/admin/login', '/urbanrenewal/select/login', '/urbanrenewal/select/forgot', '/urbanrenewal/select/reset'];
const UPGPT_PATHS = ['/upgpt/Knowledges','/upgpt/Chatbot','/upgpt/MeetingRecap','/upgpt/UserSetting','/upgpt/PermissionError', '/upgpt/PermissionErrorPortal','/upgpt/PageNotFound'];

let lang = window.localStorage.getItem('language');  
if(!lang)
  {
    lang = "zh_TW"
  }   
i18n.locale = lang

let isUpGPTUser = window.localStorage.getItem('isUpGPTUser');
let isAdmin = window.localStorage.getItem('is_staff');
let user = JSON.parse(window.localStorage.getItem('user'));
let isTechUser = false;
let isUpGPTPortalUser = false;
if(user){
  isTechUser = user['is_tech_user'] || false;
  isUpGPTPortalUser = user['is_portal_user'] || false;
}

// order page title
let tenant = window.localStorage.getItem('tenant');
let OrderListTitle, OrderDetailTitle;

OrderListTitle = i18n.t(`Bower_Title.${tenant == 'demo' || tenant == 'wiadvance'  ? 'WIADVANCE_Order_List' : 'Order_List'}`);
OrderDetailTitle = i18n.t(`Bower_Title.${tenant == 'demo' || tenant == 'wiadvance'  ? 'WIADVANCE_Order' : 'Order'}`);

let dealDeatilPage = Deal;
if(tenant == 'demo' || tenant == 'wiadvance'){
  dealDeatilPage = WiadvanceDeal;
}

const routes = [
  {
    path: "/",
    name: "UpDay",
    component: DealDashboard,
    normal: "icon-home-border",
    active: "icon-home",
  },
  {
    path: "/DealDashboard",
    name: i18n.t('Bower_Title.Oppty_Dashboard'),
    component: DealDashboard,
    normal: "icon-dashboard-border",
    active: "icon-dashboard",
  },
  {
    path: "/CaseDashboard",
    name: i18n.t('Bower_Title.Case_Dashboard'),
    component: CaseDashboard,
    normal: "icon-dashboard-border",
    active: "icon-dashboard",
  },
  {
    path: "/Activity",
    name: i18n.t('Bower_Title.Activity'),
    component: Activity,
    normal: "mdi-alien-outline",
    active: "mdi-alien",
  },
  {
    path: "/Deals",
    name: i18n.t('Bower_Title.Oppty_List'),
    component: Deals,
    normal: "icon-chatmoney-border",
    active: "icon-chatmoney",
  },
  {
    path: "/Deal/:id",
    name: i18n.t('Bower_Title.Oppty'),
    component: dealDeatilPage,
    normal: "icon-chatmoney-border",
    active: "icon-chatmoney",
  },
  {
    path: "/Login",
    name: i18n.t('Bower_Title.Login'),
    component: Login,	
  },
  {
    path: "/resetpassword",
    name: i18n.t('Bower_Title.ResetPasswordogin'),
    component: ResetPassword,	
    props: {notTenantcenterSate: true}
  },
  {
    path: "/docs/DPF.pdf",
    name: 'UpDay',
    component: DataProcessingAgreement,	
  },
  {
    path: "/Contacts",
    name: i18n.t('Bower_Title.Contacts_List'),
    component: Contacts,
    normal: "icon-contact-border",
    active: "icon-contact",
  },
  {
    path: "/Contacts/:id",
    name: i18n.t('Bower_Title.Contact'),
    component: Contact,
    normal: "icon-contact-border",
    active: "icon-contact",
  },
  {
    path: "/Companies",
    name: i18n.t('Bower_Title.Company_List'),
    component: Companies,
    normal: "icon-companies-w",
    active: "icon-companies-b",
  },
  {
    path: "/Orders",
    name: OrderListTitle,
    component: Orders,
    normal: "icon-companies-w",
    active: "icon-companies-b",
  },
  {
    path: "/Order/:id",
    name: OrderDetailTitle,
    component: Order,
    normal: "icon-companies-w",
    active: "icon-companies-b",
  },
  {
    path: "/Account/:id",
    name: i18n.t('Bower_Title.Company'),
    component: Account,
    normal: "icon-companies-w",
    active: "icon-companies-b",
  },
  {
    path: "/Logout",
    name: "Logout page",
    component: Logout,
    normal: "icon-companies-w",
    active: "icon-companies-b",
  },
  {
    path: "/Campaigns",
    name: i18n.t('Bower_Title.Campaign_List'),
    component: Campaigns,
    normal: "mdi-bullhorn-outline",
    active: "mdi-bullhorn",
  },
  {
    path: "/Campaign/:id",
    name: i18n.t('Bower_Title.Campaign'),
    component: Campaign,
    normal: "mdi-bullhorn-outline",
    active: "mdi-bullhorn",
  },
  {
    path: "/Segments",
    name: i18n.t('Bower_Title.Segment_List'),
    component: Segments,
    normal: "mdi-folder-table-outline",
    active: "mdi-folder-table-outline",
  },
  {
    path: "/Segment/:id",
    name: i18n.t('Bower_Title.Segment'),
    component: Segment,
    normal: "mdi-folder-table-outline",
    active: "mdi-folder-table-outline",
  },
  {
    path: "/Cases",
    name: i18n.t('Bower_Title.Case_List'),
    component: Cases,
    normal: "mdi-wrench-outline",
    active: "mdi-wrench",
  },
  {
    path: "/Case/:id",
    name: i18n.t('Bower_Title.Case'),
    component: Case,
    normal: "mdi-folder-table-outline",
    active: "mdi-folder-table-outline",
  },
  {
    path: "/KnowledgeArticles",
    name: i18n.t('Bower_Title.KnowledgeArticle_List'),
    component: KnowledgeArticles,
    normal: "mdi-folder-table-outline",
    active: "mdi-folder-table-outline",
  },
  {
    path: "/KnowledgeArticle/:id",
    name: i18n.t('Bower_Title.KnowledgeArticle'),
    component: KnowledgeArticle,
    // normal: "mdi-folder-table-outline",
    // active: "mdi-folder-table-outline",
  },
  {
    path: "/Setting",
    name: i18n.t('Bower_Title.Setting'),
    component: Setting,
    normal: "icon-setting-w",
    active: "icon-setting-b",
  },
  {
    path: "/PermissionError",
    name: i18n.t('Bower_Title.PermissionError'),
    component: PermissionError,
    normal: "icon-setting-w",
    active: "icon-setting-b",
  },  
  {
    path: "/Preferences",
    name: "Preferences",
    component: Preference,
    normal: "icon-home-border",
    active: "icon-home",
  },
  {
    path: "/UpChat",
    name: i18n.t('Bower_Title.UPCHAT'),
    component: UpChat,
    normal: "icon-home-border",
    active: "icon-home",
    meta:{
      upchat:true,
    }
  },
  {
    path: "/BTN",
    name: "BTN",
    component: BTN,
    normal: "icon-home-border",
    active: "icon-home",
    meta:{
      showMenu:false
    }
  },
  {
    path: "/CRM",
    name: "CRM",
    component: CRM,
    normal: "icon-home-border",
    active: "icon-home",
    meta:{
      showMenu:false
    }
  },
  {
    path: "/PageNotFound",
    name: i18n.t('Bower_Title.PageNotFoundError'),
    component: PageNotFound,
    normal: "icon-setting-w",
    active: "icon-setting-b",
  },
  // TENANT CENTER----------------------------
  {
    path: "/tenant_center",
    name: "Tenant List",
    component: TenantCenterTenantList,
    normal: "icon-home-border",
    active: "icon-home",
  },
  {
    path: "/tenant_center/login",
    name: "Tenant Center",
    component: TenantCenterLogin,
    normal: "icon-home-border",
    active: "icon-home",
  },
  {
    path: "/tenant_center/resetpassword",
    name: "Tenant Center Reset Password",
    component: ResetPassword,
    normal: "icon-home-border",
    active: "icon-home",
    props: {notTenantcenterSate: false}
  },
  {
    path: "/tenant_center/tenant_list",
    name: "Tenant List",
    component: TenantCenterTenantList,
    normal: "icon-home-border",
    active: "icon-home",
  },
  {
    path: "/tenant_center/user_list/:id",
    name: "User List",
    component: TenantCenterUserList,
    normal: "icon-home-border",
    active: "icon-home",
  },
  {
    path: "/tenant_center/usage_summary",
    name: "Tenant Usage Summary",
    component: TenantCenterUsageSumarry,
    normal: "icon-home-border",
    active: "icon-home",
  },
  // GPT----------------------------
  {
    path: "/upgpt-login",
    name: i18n.t('Bower_Title.LoginUpGPT'),
    component: UpgptLogin,
  },
  {
    path: "/sso-upgpt-login",
    name: i18n.t('Bower_Title.LoginUpGPT'),
    component: SsoUpgptLogin,
  },
  {
    path: "/sso-tsc-login",
    name: "Login TSC",
    component: SsoTscLogin,
  },
  {
    path: "/upgpt/",
    name: "UpGPT",
    component: Knowledges,
    normal: 'icon-dashboard-border',
    active: 'icon-dashboard',
    meta:{
      upgpt:isUpGPTUser,
    }
  },
  {
    path: "/upgpt/Dashboard",
    name: i18n.t('GPT_MENU.DASHBOARD'),
    normal: 'icon-dashboard-border',
    active: 'icon-dashboard',
    meta:{
      upgpt:isUpGPTUser,
    }
  },
  {
      path: '/upgpt/Knowledges',
      name: i18n.t('GPT_KNOWLEDGE.TITLE'),
      component: Knowledges,
      normal: 'mdi-book-open-variant',
      active: 'mdi-book-open-page-variant',
      meta:{
        upgpt:isUpGPTUser,
      }
  },
  {
      path: '/upgpt/Chatbot',
      name: i18n.t('GPT_AIBOTS.TITLE'),
      component: AiBots,
      normal: 'fas fa-robot',
      active: 'fas fa-robot',
      meta:{
        upgpt:isUpGPTUser,
      }
  },
  {
      path: '/upgpt/Agents',
      name: i18n.t('AGENT.TITLE'),
      component: Agents,
      normal: 'fas fa-robot',
      active: 'fas fa-robot',
      meta:{
        upgpt:isUpGPTUser,
      }
  },
  {
      path: '/upgpt/ChatHistory',
      name: i18n.t('GPT_MENU.CHAT_HISTORY'),
      component: ChatHistory,
      normal: 'far fa-comment',
      active: 'fas fa-comments',
      meta:{
        upgpt:isUpGPTUser,
      }
  },
  {
      path: '/upgpt/UserManagement',
      name: i18n.t('GPT_MENU.USER_MANAGEMENT'),
      component: ManageUsers,
      normal: 'fas fa-user-friends',
      active: 'fas fa-users-cog',
      meta:{
        upgpt:isUpGPTUser,
      }
  },
  {
      path: '/upgpt/GroupManagement',
      name: i18n.t('GPT_MENU.GROUP_MANAGEMENT'),
      component: ManageGroups,
      normal: 'fas fa-user-friends',
      active: 'fas fa-users-cog',
      meta:{
        upgpt:isUpGPTUser,
      }
  },
  {
      path: '/upgpt/UsageAnalysis',
      name: i18n.t('GPT_MENU.USAGE_ANALYSIS'),
      component: UsageAnalysis,
      normal: 'mdi-chart-pie',
      active: 'fas fa-chart-pie',
      meta:{
        upgpt:isUpGPTUser,
      }
  },
  {
      path: '/upgpt/UserAnalysis',
      name: i18n.t('GPT_MENU.USER_ANALYSIS'),
      component: UserAnalysis,
      normal: 'mdi-chart-pie',
      active: 'fas fa-chart-pie',
      meta:{
        upgpt:isUpGPTUser,
      }
  },
  {
      path: '/upgpt/UserAnalysis/:name',
      name: i18n.t('GPT_THREAD_ANALYSIS.THREAD_ANALYSIS'),
      component: ThreadAnalysis,
      normal: 'mdi-chart-pie',
      active: 'fas fa-chart-pie',
      meta:{
        upgpt:isUpGPTUser,
      }
  },
  {
      path: '/upgpt/LoginPageSetting',
      name: i18n.t('LOGIN_PAGE_SETTING.TITLE'),
      component: LoginPageSetting,
      normal: 'mdi-cog',
      active: 'mdi-cog',
      meta:{
        upgpt:isUpGPTUser,
      }
  },
  {
    path: '/upgpt/Knowledges/:id',
    name: i18n.t('GPT_MENU.KNOWLEDGE'),
    component: Knowledge,
    normal: 'mdi-book-open-variant',
    active: 'mdi-book-open-page-variant',
    meta:{
      upgpt:isUpGPTUser,
    }
  },
  {
    path: '/upgpt/Chatbot/:id',
    name: i18n.t('GPT_MENU.CHATBOT'),
    component: AiBot,
    normal: 'mdi-book-open-variant',
    active: 'mdi-book-open-page-variant',
    meta:{
      upgpt:isUpGPTUser,
    }
  },
  {
    path: '/upgpt/Uploadrecord/',
    name: i18n.t('GPT_MENU.UPLOADSTATUS'),
    component: UploadRecord,
    normal: 'mdi-folder-upload',
    active: 'mdi-folder-upload',
    meta:{
      upgpt:isUpGPTUser,
    }
  },
  {
    path: '/upgpt/UserSetting/',
    name: i18n.t('SETTING.PERSONALSETTING'),
    component: GptUserSetting,
    normal: "mdi-account",
    active: "mdi-account",
    meta:{
      upgpt:isUpGPTUser,
    }
  },
  {
    path: '/upgpt/MeetingRecap/',
    name: i18n.t('GPT_MEETINGRECAPS.TITLE'),
    component: MeetingRecaps,
    normal: "mdi-account",
    active: "mdi-account",
    meta:{
      upgpt:isUpGPTUser,
    }
  },
  {
    path: '/upgpt/MeetingRecap/:id',
    name: i18n.t('GPT_MEETINGRECAP.TITLE'),
    component: MeetingRecap,
    normal: "mdi-account",
    active: "mdi-account",
    meta:{
      upgpt:isUpGPTUser,
    }
  },
  {
    path: '/upgpt/AINotebook/',
    name: i18n.t('GPT_AINOTEBOOK.TITLE'),
    component: AINotebooks,
    normal: "mdi-account",
    active: "mdi-account",
    meta:{
      upgpt:isUpGPTUser,
    }
  },
  {
    path: '/upgpt/AINotebook/:id',
    name: i18n.t('GPT_MENU.AINOTEBOOK')+" ",
    component: AINotebook,
    normal: "mdi-account",
    active: "mdi-account",
    meta:{
      upgpt:isUpGPTUser,
    }
  },
  {
    path: "/upgpt/PageNotFound",
    name: i18n.t('Bower_Title.PageNotFoundError')+" ",
    component: PageNotFound,
    normal: "icon-setting-w",
    active: "icon-setting-b",
  },
  {
    path: "/upgpt/PermissionError",
    name: i18n.t('Bower_Title.PermissionError')+" ",
    component: PermissionError,
    normal: "icon-setting-w",
    active: "icon-setting-b",
  },
  {
    path: "/upgpt/PermissionErrorPortal",
    name: i18n.t('Bower_Title.PermissionError'),
    component: PermissionErrorPortal,
    normal: "icon-setting-w",
    active: "icon-setting-b",
  },   
  // UPMEETING----------------------------
  {
    path: "/upmeeting",
    name: i18n.t('UPMEETING.LOGIN')+" ",
    component: UpMeeting,
    normal: "icon-setting-w",
    active: "icon-setting-b",
  },
    // UPPORTAL
  {
  path: '/UpGPT_Portal',
  name: 'UpGPT Portal',
  component: UpPortal
  },
  {
    path: '/image_url',
    name: 'UpGPT Portal',
    component: UpPortalDisplayImage
  },
  {
    path: '/Manage_Work_Agent_Definition',
    name: 'Manage Work Agent Definition',
    component: ManageWorkAgentDefinition
  },
  // Urban Renewal Admin----------------------------
  {
    path: '/urbanrenewal/admin/login',
    name: 'Urban Renewal Admin Login',
    component: UrbanRenewalAdminLogin,
    beforeEnter: (to, from, next) => {
      // Persist tenant from the URL query so subsequent (tenant-scoped) API
      // calls — logo fetch, login, post-login feature-flag check — target the
      // correct schema. The feature-flag itself is enforced after login by
      // urbanRenewalAdminGuard (where tenant + token are available); gating the
      // login page on an authed preference call is not possible pre-login.
      if (to.query.tenant) {
        window.localStorage.setItem('tenant', to.query.tenant);
      }
      next();
    },
  },
  {
    path: '/urbanrenewal/admin',
    redirect: '/urbanrenewal/admin/basicdata',
  },
  {
    path: '/urbanrenewal/admin/basicdata',
    name: 'Urban Renewal Admin Basic Data',
    component: UrbanRenewalAdminBasicData,
    beforeEnter: urbanRenewalAdminGuard,
  },
  {
    path: '/urbanrenewal/admin/statistics',
    name: 'Urban Renewal Admin Statistics',
    component: UrbanRenewalAdminStatistics,
    beforeEnter: urbanRenewalAdminGuard,
  },
  {
    path: '/urbanrenewal/admin/heatmap',
    name: 'Urban Renewal Admin Heatmap',
    component: UrbanRenewalAdminHeatmap,
    beforeEnter: urbanRenewalAdminGuard,
  },
  {
    path: '/urbanrenewal/admin/simulation',
    name: 'Urban Renewal Admin Simulation',
    component: UrbanRenewalAdminSimulation,
    beforeEnter: urbanRenewalAdminGuard,
  },
  {
    path: '/urbanrenewal/admin/manualinput',
    name: 'Urban Renewal Admin Manual Input',
    component: UrbanRenewalAdminManualInput,
    beforeEnter: urbanRenewalAdminGuard,
  },
  {
    path: '/urbanrenewal/admin/projectsettings',
    name: 'Urban Renewal Admin Project Settings',
    component: UrbanRenewalAdminProjectSettings,
    beforeEnter: urbanRenewalAdminGuard,
  },
  {
    path: '/urbanrenewal/admin/adminsettings',
    name: 'Urban Renewal Admin Admin Settings',
    component: UrbanRenewalAdminAdminSettings,
    beforeEnter: urbanRenewalAdminGuard,
  },
  // Urban Renewal 前台選配 -------------------------
  {
    path: '/urbanrenewal/select/login',
    name: 'Urban Renewal Select Login',
    component: UrbanRenewalSelectLogin,
    beforeEnter: (to, from, next) => {
      if (to.query.tenant) window.localStorage.setItem('tenant', to.query.tenant);
      next();
    },
  },
  {
    path: '/urbanrenewal/select/forgot',
    name: 'Urban Renewal Select Forgot',
    component: UrbanRenewalSelectForgotPassword,
    beforeEnter: (to, from, next) => {
      if (to.query.tenant) window.localStorage.setItem('tenant', to.query.tenant);
      next();
    },
  },
  {
    path: '/urbanrenewal/select/reset',
    name: 'Urban Renewal Select Reset',
    component: UrbanRenewalSelectResetPassword,
    beforeEnter: (to, from, next) => {
      if (to.query.tenant) window.localStorage.setItem('tenant', to.query.tenant);
      next();
    },
  },
  {
    path: '/urbanrenewal/select',
    name: 'Urban Renewal Select',
    component: UrbanRenewalSelect,
    beforeEnter: urbanRenewalSelectGuard,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
})

const unAuthenticatedAndPrivatePage = (path) => (!PUBLIC_PATHS.includes(path)
  && !(ACCESS_TOKEN in window.localStorage)
  && !(REFRESH_TOKEN in window.localStorage));

const tenantUnAuthenticatedAndPrivatePage = (path) => (!PUBLIC_PATHS.includes(path)
  && !(TENANTCENTER_ACCESS_TOKEN in window.localStorage)
  && !(TENANTCENTER_REFRESH_TOKEN in window.localStorage));

router.beforeEach((to, from, next) => {
  if (to.path === '/Logout') next();
  if ((to.path === '/upgpt' || to.path === '/upgpt_portal') && to.query.access) {
    const parseBool = (value) => String(value).toLowerCase() === 'true';
    const { access,refresh,id_token,username,userid,first_name,last_name,email,change_password,language,location,pic,is_staff,is_service_agent,is_tech_user,is_portal_user,is_view_only_user,default_value,upchat,status,fcm_token,upgpt, tenant, idle_time_limit, need_redirect} = to.query;

    window.localStorage.setItem('access_token', access);
    window.localStorage.setItem('refresh_token', refresh);
    window.localStorage.setItem('id_token', id_token);
    window.localStorage.setItem('tenant', tenant);

    var user = { 
      userid: parseInt(userid, 10),
      pic: pic,
      username: username,
      first_name: first_name,
      last_name: last_name,
      email: email,
      change_password: parseBool(change_password),
      language: language,
      location: location,
      is_service_agent: parseBool(is_service_agent),
      is_tech_user: parseBool(is_tech_user),
      is_view_only_user: parseBool(is_view_only_user),
      is_portal_user: parseBool(is_portal_user),
      status: status,
      is_staff: is_staff.toLowerCase(),
      fcm_token: fcm_token,
      default_value: default_value,
      upgpt:parseBool(upgpt),
      upchat_sso_link: "",
      upchat_dashboard: "",
      upchat_host: "", 
      idle_time_limit: idle_time_limit,
    };
    window.localStorage.setItem('isUpchatUser', upchat);
    window.localStorage.setItem('isUpGPTUser', parseBool(upgpt));
    window.localStorage.setItem('upchat_login', false);
    window.localStorage.setItem('user', JSON.stringify(user));
    window.localStorage.setItem('need_redirect', need_redirect);
    window.localStorage.setItem('language', language);
    window.localStorage.setItem('location', location);
    window.localStorage.setItem('is_staff', parseBool(is_staff));     
    window.localStorage.setItem('fcm_token', fcm_token);
    window.localStorage.setItem('sso', true);
    window.localStorage.setItem('lastActive', Math.floor(Date.now() / 1000));
    window.localStorage.setItem('idleTimeLimit', idle_time_limit);

    // iframe和網頁版共有
    const expireDate = new Date();
    expireDate.setDate(expireDate.getDate() + 30);
    document.cookie = "access_token=" + access + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
    document.cookie = "refresh_token=" + refresh + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
    document.cookie = "id_token=" + id_token + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
    document.cookie = "tenant=" + tenant + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
    document.cookie = "isUpchatUser=" + upchat + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
    document.cookie = "isUpGPTUser=" + upgpt + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
    document.cookie = `upchat_login=false;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
    const userStr = encodeURIComponent(JSON.stringify(user));
    document.cookie = `user=${userStr};secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
    document.cookie = "need_redirect" + need_redirect + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
    document.cookie = "language=" + language + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
    document.cookie = "location=" + location + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
    document.cookie = "is_staff=" + parseBool(is_staff) + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
    document.cookie = "fcm_token=" + fcm_token + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
    document.cookie = "sso=" + true + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
    document.cookie = "lastActive=" + Math.floor(Date.now() / 1000) + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
    document.cookie = "idleTimeLimit=" + idle_time_limit + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
    
    if(need_redirect === "False") {
      window.close();
    }
    i18n.locale = language
    console.log("success");
    if (to.path === '/upgpt') {
      next({
        path: '/upgpt'
      });
    }else{
      next({
        path: '/upgpt_portal'
      });
    }
  }else if(to.path.startsWith('/tenant_center')){
    let tenant_center_lang = window.localStorage.getItem('tenantcenter_language');
    if(!tenant_center_lang)  tenant_center_lang = "zh_TW"
    i18n.locale = tenant_center_lang

    if (tenantUnAuthenticatedAndPrivatePage(to.path)) {
      let toPath = `/tenant_center/login?next=${to.path}`;
      next(toPath);
    }else{
      next()
    }
  }else{
    // Urban Renewal Admin: unauthenticated access to protected admin pages → admin login
    if (
      to.path.toLowerCase().startsWith('/urbanrenewal/admin') &&
      !to.path.toLowerCase().startsWith('/urbanrenewal/admin/login') &&
      !(ACCESS_TOKEN in window.localStorage)
    ) {
      return next('/urbanrenewal/admin/login');
    }
    // Urban Renewal Select (前台選配): unauthenticated access to protected select pages → select login
    // login / forgot / reset 均為公開頁面，需一併放行，否則忘記密碼/重設密碼頁會被誤導回登入
    {
      const p = to.path.toLowerCase();
      if (p.startsWith('/urbanrenewal/select')) {
        const selectPublic = p.startsWith('/urbanrenewal/select/login')
          || p.startsWith('/urbanrenewal/select/forgot')
          || p.startsWith('/urbanrenewal/select/reset');
        if (!selectPublic && !window.localStorage.getItem('ur_select_token')) {
          return next('/urbanrenewal/select/login');
        }
        // 前台為獨立認證（landowner token），不走 CRM access_token 檢查；
        // 於此終結導航，避免落到下方 unAuthenticatedAndPrivatePage 被誤導去 CRM 登入。
        return next();
      }
    }
    if (unAuthenticatedAndPrivatePage(to.path)) {
      let nowPath = router.currentRoute.fullPath;
      let tenantParam = 'login?tenant=';
  
      let loginBasePath = '';
      if (window.localStorage.getItem('sso') === "true") {
        loginBasePath = '/sso-upgpt-login';
      } else if(to.path.toLowerCase().includes('/upgpt')) {
        loginBasePath = '/upgpt-login';
      } else if (to.path.toLowerCase().includes('/tenant_center')) {
        loginBasePath = '/tenant_center/login';
      } else if (to.path.toLowerCase().includes('/sso-upgpt-login')) {
        loginBasePath = '/sso-upgpt-login';
      } else if (to.path.toLowerCase().includes('/sso-tsc-login')) {
        loginBasePath = '/sso-tsc-login';
      } else {
        loginBasePath = '/login';
      }
      let toPath = `${loginBasePath}?next=${to.path}`;
      let query_params = nowPath.slice(nowPath.indexOf(tenantParam) + tenantParam.length);
      let tenant = (query_params.includes('&')) ? query_params.split('&')[0] : query_params;
      if(nowPath.includes(tenantParam)) {
        toPath = `${loginBasePath}?tenant=${tenant}&next=${to.path}`;
      }
      next(toPath);
    } else {
      // if url has upchat=Y, redirect to upchat sso link if available, else go to dashboard
      var fp = to.fullPath;
      if (fp.includes('upchat=Y')) {
        let user = window.localStorage.user;
        if (user != null && user != undefined) {
          let userJson = JSON.parse(window.localStorage.user);
          if (userJson.upchat_sso_link != '')
            window.location.href = userJson.upchat_sso_link; 
        } else {
          next();
        }
      } else {
        next();
      }
    }
  }
});

// router.beforeEach((to, from, next) => {
//   document.title = to.name;
//   next();
// });

router.beforeEach((to, from, next) => {
    if (to.path === '/Logout') next();
    if(!to.path.includes('upmeeting')){
      document.title = to.name;
      localStorage.setItem('title', to.name);
    }
    if(to.params.id){
      sessionStorage.setItem('page_id', to.params.id);
    }
    if(isTechUser){
      if(to.path.includes('/Deal/') || to.path.includes('/Deals') || to.path.includes('/Setting') || to.path.includes('/Login') || to.path.includes('/login') || to.path.includes('/PermissionError') || to.path.includes('/PageNotFound')){
        next();
      }else{
        next('/Deals');
      }
    }else{
      // 如果目標路由包含 /upgpt，進入 UpGPT 頁面
      if(to.path.includes('/upgpt')){
        // 如果是登入頁
        if(to.path.includes('/upgpt-login')){
          next();
        }
        // 如果不是 UpGPTUser，無權限使用 UpGPT），導向首頁
        else if(isUpGPTUser == "false"){
          next('/');
        }
        // 若為管理員（擁有最高權限）
        else if(isAdmin!='false'){
          next();
        }else{
        // 若為一般員工的路由控制
          if(UPGPT_PATHS.some(el => to.path.includes(el))){
            next();
          }else{
            // 若為一般員工是 portal 使用者
            if(isUpGPTPortalUser == false){
              if(to.path == 'UpGPT_Portal' || to.path == '/UpGPT_Portal' || to.path == '/upgpt_portal'){
                next('upgpt/PermissionErrorPortal');
              }
              else if(to.path == '/upgpt' || to.path == '/upgpt/'){
                next();
              }
              else{
                next('/upgpt/PermissionError');
              }
            }else{
              if(to.path.toLowerCase().includes('/upgpt_portal')){
                next('/UpGPT_Portal/');
              }else if(to.path == '/upgpt' || to.path == '/upgpt/'){
                next();
              }else{
                next('/upgpt/PermissionError');
              }
            }
            // if(to.path == '/upgpt' || to.path == '/upgpt/'){
            //   next('/upgpt/MeetingRecap');
            // }else if(isUpGPTPortalUser == true && to.path.toLowerCase().includes('/upgpt_portal')){
            //   next('/UpGPT_Portal/');
            // }else if(isUpGPTPortalUser == false && to.path.toLowerCase().includes('/upgpt_portal')){
            //   next('upgpt/PermissionErrorPortal');
            // }else{
            // // 其他不符合條件的狀況，一律導向無權限頁面
            //   next('/upgpt/PermissionError');
            // }
          }
        }
      }
      else{
        next();
      }
    }
});


router.afterEach((to) => {
  let favicon;
  if(to.path == '/sso-tsc-login'){
    favicon = '/TSC-icon.png';
    let link = document.querySelector("link[rel~='icon']");
    if(link){
      link.href = favicon;
    }
  }
})

export default router
